import { localizeMessage } from 'components/LocalizedMessage';
import { IFederalChannel } from '../types';

export const FEDERAL_CHANNEL: IFederalChannel = {
  value: 'federal-channels',
  label: localizeMessage({ id: 'federalChannels' }),
};

export const DEFAULT_LENGTH_SHARES = [{ share: 100, length: 20 }];
